import utils from 'utils';

export default Object.create(Object.prototype, {
    BASE_URL: {
        get() {
            return utils.app.env('BACKEND_BASE_URL', { value: 'http://localhost:8080' });
        }
    }
});
